<template>
  <div class="releases">
    <h1>Releases</h1>
    <h4>Recent updates to PEA 2.0</h4>
    <hr>
    <div class="update">
      <h5 class="update-date">August 26, 2024</h5>
      <h5 class="update-title">SSO to PEA Now Available</h5>
      <p>
        Single Sign On with your Microsoft Account is now available.
      </p>
    </div>
    <div class="update">
      <h5 class="update-date">June 12, 2019</h5>
      <h5 class="update-title">GKN to PEA redirect login removed</h5>
      <p>
        Feature will be improved and added back in the future.
      </p>
    </div>
    <div class="update">
      <h5 class="update-date">May 15, 2019</h5>
      <h5 class="update-title">Capital Budget ID Table Display</h5>
      <p>
        Hovering your cursor over the capital budget ID on any table will now display the full value.
      </p>
    </div>
    <div class="update">
      <h5 class="update-date">April 25, 2019</h5>
      <h5 class="update-title">Customer Funded Tooling removed</h5>
      <p>
        After analysis, 'Customer Funded Tooling' has been removed.
      </p>
      <p>
        Wording in the Financial Assets section has also been slightly updated.
      </p>
    </div>
    <div class="update">
      <h5 class="update-date">March 18, 2019</h5>
      <h5 class="update-title">PEA Techinical updates</h5>
      <p>
        Error messages provide more feedback. File names shortened when using Internet Explorer.
      </p>
    </div>
    <div class="update">
      <h5 class="update-date">March 7, 2019</h5>
      <h5 class="update-title">PEA Document Section Restyled</h5>
      <p>
        The document section on the edit PEA page has been restyled to better accomodate long file names.
      </p>
    </div>
    <div class="update">
      <h5 class="update-date">Feb 26, 2019</h5>
      <h5 class="update-title">Fixed Grouping Reports Search</h5>
      <p>
        A grouping report search will now display the intended results.
      </p>
    </div>
    <div class="update">
      <h5 class="update-date">Feb 14, 2019</h5>
      <h5 class="update-title">Fix Reports Export</h5>
      <p>Bug fixes for special character exports and correcting a column name. </p>
    </div>
    <div class="update">
      <h5 class="update-date">Feb 11, 2019</h5>
      <h5 class="update-title">Added Print And Email Ability To PEA Page</h5>
      <p>The top right of the PEA page now has 2 icons. </p>
      <p>  The first icon will generate an email message with a link to the current PEA page. </p>
      <p>  The second icon will open a new Print page to print the current PEA via the browser.</p>
      <img src="@/assets/updates/emailPrintUpdate.png" class="" />
    </div>
    <div class="update">
      <h5 class="update-date">Jan 30, 2019</h5>
      <h5 class="update-title">Authorization Displays Dates</h5>
      <p>
        Authorization section of PEA page now displays the approve/denial date.
      </p>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>

<style scoped>
  h1 {
    margin-left: -1px;
  }

  h4 {
    margin-bottom: 20px;
  }

  .releases {
    margin-left: 80px;
  }

  .update {
    margin-bottom: 40px;
  }

  .update-date {
    font-weight: 600;
  }

  .update-title {
    margin-top: 10px;
    text-indent: 1%;
  }

  p {
    font-size: 16px;
    text-indent: 2%;
  }

</style>
